import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/m1UmQ2occGCHx5ZvyY5TU3/BV-Group-Logo.png';
interface BVLogoProps {
  size?: number;
  className?: string;
  darkBackground?: boolean;
}
export function BVLogo({
  size = 48,
  className = '',
  darkBackground = false
}: BVLogoProps) {
  return <div className={`inline-flex ${className}`} data-id="element-71">
      <img src={LOGO_URL} alt="BV Group - We Define Hospitality" style={{
      height: size,
      width: 'auto'
    }} className={`object-contain ${darkBackground ? 'mix-blend-lighten' : ''}`} data-id="element-72" />
    </div>;
}